// Timezone-based privacy-regime detection. EU regime = the visitor gets
// cookieless PostHog by default and sees the cookie banner; everyone else
// gets full-cookie analytics immediately (owner decision: doubt → non-EU).
// Non-EEA European timezones (Istanbul, Moscow…) are knowingly classified
// EU — worst case they see one extra banner.

const EU_ATLANTIC = new Set([
  "Atlantic/Canary",
  "Atlantic/Madeira",
  "Atlantic/Azores",
  "Atlantic/Reykjavik",
  "Atlantic/Faroe",
]);

export function isEUTimeZone(tz) {
  if (!tz) return false;
  return tz.startsWith("Europe/") || EU_ATLANTIC.has(tz);
}

export function isEURegime() {
  try {
    return isEUTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch {
    return false;
  }
}
